import { z } from 'zod';
import { JsonSchema } from '../../../helpers';
import { ConfigsStepPostSignQaAnswersTranslations } from './configs-step-post-sign-qa-answers-translations';

export const ConfigsStepPostSignQaAnswers = z.object({
  id: z.string().uuid(),
  question_id: z.string().uuid(),
  metadata: JsonSchema.nullable(),
  translate: ConfigsStepPostSignQaAnswersTranslations.optional(),
  is_visible: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ConfigsStepPostSignQaAnswersT = z.infer<
  typeof ConfigsStepPostSignQaAnswers
>;

export const ConfigsStepPostSignQaAnswersInsert =
  ConfigsStepPostSignQaAnswers.partial().merge(
    ConfigsStepPostSignQaAnswers.pick({ question_id: true })
  );

export type ConfigsStepPostSignQaAnswersInsertT = z.infer<
  typeof ConfigsStepPostSignQaAnswersInsert
>;

export const ConfigsStepPostSignQaAnswersUpdate =
  ConfigsStepPostSignQaAnswers.omit({
    id: true,
    created_at: true,
  }).partial();

export type ConfigsStepPostSignQaAnswersUpdateT = z.infer<
  typeof ConfigsStepPostSignQaAnswersUpdate
>;
